import { resources } from 'js/resources';
import React from 'react';

let changeSite = (item) => {
  window.open(item.target.value, '_self');
};

export class Header extends React.Component {
  onMenuSelect() {}

  render() {
    //
    let filterOptions = [
      { payload: '1', text: 'Select Category' },
      { payload: '2', text: 'Card One' },
      { payload: '3', text: 'Card Two' },
      { payload: '4', text: 'Card Three' },
      { payload: '5', text: 'Card Four' },
      { payload: '6', text: 'Card Five' },
      { payload: '7', text: 'Card Six' },
      { payload: '7', text: 'Card Seven' },
    ];

    let navPages = [
      { payload: '1', text: 'Download' },
      { payload: '2', text: 'More Info' },
    ];

    let socialMedia = [
      {
        imageSource: resources.facebook,
        url:
          'https://www.facebook.com/pages/National-Alliance-for-Public-Safety-GIS-Foundation/116831945040882',
      },
      {
        imageSource: resources.twitter,
        url: 'https://www.twitter.com/napsgfoundation',
      },
      {
        imageSource: resources.youtube,
        url: 'https://www.twitter.com/napsgfoundation',
      },
    ];
    return (
      <header id='head' className='wrap'>
        <hgroup id='logo'>
          <h1>
            <a href='https://www.napsgfoundation.org/'>NAPSG Foundation</a>
          </h1>
        </hgroup>

        <ul id='social-icons'>
          <li className='facebook'>
            <a
              href='https://www.facebook.com/pages/National-Alliance-for-Public-Safety-GIS-Foundation/116831945040882'
              target='_blank'
            >
              Facebook
            </a>
          </li>
          <li className='twitter'>
            <a href='https://www.twitter.com/napsgfoundation' target='_blank'>
              Twitter
            </a>
          </li>
          <li className='youtube'>
            <a href='https://www.youtube.com/user/napsggis' target='_blank'>
              Youtube
            </a>
          </li>
        </ul>

        <nav id='primary-navigation'>
          <ul>
            <li className='menu-item menu-item-type-post_type menu-item-object-page menu-item-560'>
              <a href='https://www.napsgfoundation.org/'>Home</a>
            </li>
            <li className='menu-item menu-item-type-post_type menu-item-object-page menu-item-556'>
              <a href='https://www.napsgfoundation.org/about/'>About Us</a>
            </li>
            <li className='menu-item menu-item-type-post_type menu-item-object-page menu-item-559'>
              <a href='https://www.napsgfoundation.org/work-with-us'>
                Working With Us
              </a>
            </li>
            <li className='menu-item menu-item-type-custom menu-item-object-custom menu-item-554'>
              <a href='https://www.napsgfoundation.org/all-resources'>
                Resources
              </a>
            </li>
            <li className='menu-item menu-item-type-post_type menu-item-object-page menu-item-557'>
              <a href='https://www.napsgfoundation.org/events/'>Events</a>
            </li>
            <li className='menu-item menu-item-type-post_type menu-item-object-page menu-item-558'>
              <a href='https://www.napsgfoundation.org/news/'>News</a>
            </li>
          </ul>

          <div className='mobile-menu button'>
            <i className='icon-reorder'></i> Menu
            <select id='menu-mobile' onChange={changeSite.bind(this)}>
              <option></option>
              <option value='https://www.napsgfoundation.org/'>Home</option>
              <option value='https://www.napsgfoundation.org/about/'>
                About Us
              </option>
              <option value='https://www.napsgfoundation.org/work-with-us'>
                Working With Us
              </option>
              <option value='https://www.napsgfoundation.org/all-resources'>
                Resources
              </option>
              <option value='https://www.napsgfoundation.org/events/'>
                Events
              </option>
              <option value='https://www.napsgfoundation.org/news/'>
                News
              </option>
            </select>
          </div>
        </nav>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/main/header.js